import _Vue from 'vue';

import { TContainer } from './grids/container/container';
import { TRow } from './grids/row/row';
import { TCol } from './grids/col/col';
import { TCard } from './card/card';

export default {
    install(Vue: typeof _Vue, options?: any) {
        Vue.component('t-container', TContainer);
        Vue.component('t-row', TRow);
        Vue.component('t-col', TCol);
        Vue.component('t-card', TCard);
    }
};
